import { Modal, ModalVariant } from '@hub/common/Modal/Modal';
import React from 'react';
import type { IbdRecommendation } from '@hub/free-form-hub/common/recommendations/ibd-recommendation/useIbdRecommendation';
import type { IgeRecommendationResults } from '@hub/free-form-hub/common/recommendations/ige-recommendation/useIgeRecommendation';
import type { Session } from '@hub/hooks/states/useSessionStore';
import { NbsRecommendation } from '@hub/free-form-hub/common/recommendations/NbsRecommendation';

type NbsRecommendationDialogProps = {
  visible: boolean;
  onClose: () => void;
  ibdRecommendation: IbdRecommendation;
  igeRecommendation: IgeRecommendationResults;
  quantity: number;
  session: Session;
  fileDimensions: Record<string, number>;
};

export const NbsRecommendationDialog = ({
  visible,
  ibdRecommendation,
  igeRecommendation,
  fileDimensions,
  quantity,
  session,
  onClose,
}: NbsRecommendationDialogProps) => (
  <Modal staticBackdrop variant={ModalVariant.DEFAULT} visible={visible} onClose={onClose}>
    <NbsRecommendation
      ibdRecommendation={ibdRecommendation}
      igeRecommendation={igeRecommendation}
      quantity={quantity}
      session={session}
      fileDimensions={fileDimensions}
    />
  </Modal>
);
